"use client";
import * as React from "react";
import { Typography, List, ListItemButton, ListItemText } from "@mui/material";
import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { WorkspaceCard } from "../Common/WorkspaceCard";
import { Row } from "../Common/Row";
import type { ProjectSession } from "../../api/projects";

interface Props {
  projectId: string;
  sessions: ProjectSession[];
}

export function ProjectConversationsList({ sessions }: Props) {
  return (
    <WorkspaceCard interactive={false}>
      <Row align="center" gap={1}>
        <MessageSquare size={16} />
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Conversations ({sessions.length})
        </Typography>
      </Row>
      {sessions.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          No conversations yet. Use “New chat” above to start one in this project.
        </Typography>
      ) : (
        <List dense data-ph-scope="conversations" sx={{ mt: 0.5 }}>
          {sessions.map((s) => (
            <ListItemButton
              key={s.id}
              data-ph="open"
              component={Link}
              to={`/?session=${encodeURIComponent(s.id)}`}
              sx={{ borderRadius: 1.5 }}
            >
              <ListItemText
                primary={s.title}
                slotProps={{ primary: { noWrap: true, variant: "body2" } }}
              />
            </ListItemButton>
          ))}
        </List>
      )}
    </WorkspaceCard>
  );
}
